export const environment = {
  production: false,
  developmentMode: false,
};
